module.exports = __webpack_public_path__ + "static/nekola-6227ebb955406b570ed971616d3f7408.jpg";